import { render, staticRenderFns } from "./FamousFormRead.vue?vue&type=template&id=787ec2a9&"
import script from "./FamousFormRead.vue?vue&type=script&lang=js&"
export * from "./FamousFormRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports